//tracking params
window._paq = window._paq || [];
/* tracker methods like "setCustomDimension" should be called before "trackPageView" */
_paq.push(['trackPageView']);
_paq.push(['enableLinkTracking']);
_paq.push(['setTrackerUrl', "https://an.now-here.com/piwik.php"]);
_paq.push(['setSiteId', '13']);
